/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Reviews_Yourdashboard2Inputs */

const id_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dasbor Anda`)
};

const ms_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`papan pemuka anda`)
};

const da_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dit dashboard`)
};

const de_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihrem Dashboard`)
};

const en_us2_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`your dashboard`)
};

const es_es2_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tu panel`)
};

const es_mx2_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tu tablero`)
};

const fil_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iyong dashboard`)
};

const fr_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`votre tableau de bord`)
};

const it_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`la tua dashboard`)
};

const hu_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`irányítópultodra`)
};

const nl_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`je dashboard`)
};

const no_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ditt dashbord`)
};

const pl_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`swojego panelu`)
};

const pt_br2_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`seu painel`)
};

const pt_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`o seu painel`)
};

const ro_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`panoul tău de bord`)
};

const fi_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hallintapaneeliisi`)
};

const sv_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`din panel`)
};

const vi_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bảng điều khiển của bạn`)
};

const tr_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`paneliniz`)
};

const cs_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`svůj dashboard`)
};

const bg_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`вашето табло`)
};

const ru_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вашу панель`)
};

const uk_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`вашої панелі`)
};

const ar_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لوحة التحكم الخاصة بك`)
};

const hi_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपने डैशबोर्ड पर`)
};

const th_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แดชบอร์ดของคุณ`)
};

const ja_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダッシュボード`)
};

const zh_cn2_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的仪表盘`)
};

const zh_hant1_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的儀表板`)
};

const ko_offerdetail_reviews_yourdashboard2 = /** @type {(inputs: Offerdetail_Reviews_Yourdashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 대시보드`)
};

/**
* | output |
* | --- |
* | "your dashboard" |
*
* @param {Offerdetail_Reviews_Yourdashboard2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_yourdashboard2 = /** @type {((inputs?: Offerdetail_Reviews_Yourdashboard2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Yourdashboard2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "da") return da_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "de") return de_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "it") return it_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "no") return no_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "th") return th_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_yourdashboard2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_yourdashboard2(inputs)
	return ko_offerdetail_reviews_yourdashboard2(inputs)
});
export { offerdetail_reviews_yourdashboard2 as "offerDetail.reviews.yourDashboard" }